<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Coupon</h1>
                    <p>Gestion des coupons de connexion</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.voucher.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un coupon</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Utilisations', value:'total_used'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Montant', value:'value'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Token', value:'token'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'published', value:'publication_state_id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.voucher.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                              <icon name="gift-01"/>
                            </figure>
                        </div>
                        <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name">
                          <strong class="highlight">{{ item.name }}</strong>
                          <p>{{ item.description }}</p>
                        </div>
                        <div data-field="total_used">{{ item.total_used }}/{{ item.limit<=0?'∞':item.limit }}</div>
                        <div data-field="value">{{ item.value }}{{ item.is_number?'.-':'%' }}</div>
                        <div data-field="token">
                          <strong class="token" v-if="item.tokens.length > 5">{{ item.tokens.slice(0, 5).join(', ') }}, (+{{ item.tokens.length - 5 }})</strong>
                          <strong class="token" v-if="item.tokens.length <= 5">{{ item.tokens.join(', ') }}</strong>
                        </div>
                        <div><published v-model="item.published" :date-start="item.start_at" :date-end="item.end_at"></published></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxshop.voucher.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.voucher.update',item.id)"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.voucher.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import VoucherService from './VoucherService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return VoucherService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/voucher/Index.vue